;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();export default function Communicate() {
  return (
    <svg width="179" height="151" viewBox="0 0 179 151" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_239_1437)">
        <path
          d="M66.7248 91.3762H119.872L147.551 118.223C149.938 120.538 154.027 118.9 154.027 115.626V91.3762H165.422C171.709 91.3762 176.817 86.4359 176.817 80.3241V14.0542C176.817 7.95656 171.724 3.0022 165.422 3.0022H66.7248C60.4379 3.0022 55.3299 7.94244 55.3299 14.0542V80.3382C55.3299 86.4359 60.4234 91.3903 66.7248 91.3903V91.3762Z"
          stroke="#455A63"
          strokeWidth="3"
          stroke-miterlimit="10"
        />
        <path
          d="M43.9496 32.4602H13.5778C7.29097 32.4602 2.18292 37.4005 2.18292 43.5122V109.796C2.18292 115.894 7.27642 120.848 13.5778 120.848H28.7564V145.098C28.7564 148.373 32.8458 150.024 35.2324 147.695L62.9119 120.848H93.2837C99.5706 120.848 104.679 115.908 104.679 109.796V102.428"
          stroke="#455A63"
          strokeWidth="3"
          stroke-miterlimit="10"
        />
        <path d="M93.2983 47.1821H100.895" stroke="#FFB400" strokeWidth="3" stroke-linejoin="round" />
        <path d="M112.275 47.1821H119.872" stroke="#FFB400" strokeWidth="3" stroke-linejoin="round" />
        <path d="M131.267 47.1821H138.849" stroke="#FFB400" strokeWidth="3" stroke-linejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_239_1437">
          <rect width="179" height="150" fill="white" transform="translate(0 0.88501)" />
        </clipPath>
      </defs>
    </svg>
  );
}
